let url = "https://api.orenmart.com/admin";

// let url = "http://192.168.0.103:3754/admin";
export let cdnUrl = "https://cdnapi.orenmart.com/v1/admin";
// export let cdnUrl = "http://192.168.0.105:3404/v1/admin";

export let globalCdnUrl = "https://cdnapi.orenmart.com/v1/admin";
export default url;
